import QuantitySelector from "../../_components/onboardingFlow/QuantitySelector";
import { colorOutlineOutline } from "@/app/(styles)/variables";
export const QuesSheetCheckboxButtons = ({
  currentQuestionData,
  setAnswers,
  answers
}) => {
  const options = currentQuestionData.options;

  // Get current answers values object (for internal use)
  const getCurrentAnswersValues = () => {
    const answerData = answers[currentQuestionData.id];
    // Handle migration from old format or new format
    if (answerData?.values) {
      // New formatted format
      return answerData.values;
    }
    if (answerData && typeof answerData === "object" && !answerData.question) {
      // Old format (direct values object)
      return answerData;
    }
    if (Array.isArray(answerData)) {
      // Legacy array format
      const obj = {};
      answerData.forEach(value => {
        const option = options.find(opt => opt.value === value);
        obj[value] = option?.allowQuantity ? 1 : 1;
      });
      return obj;
    }
    return {};
  };
  const formatAnswerString = valuesObj => {
    const selectedOptions = [];
    Object.keys(valuesObj).forEach(optionValue => {
      const option_0 = options.find(opt_0 => opt_0.value === optionValue);
      if (option_0) {
        const quantity = valuesObj[optionValue];
        selectedOptions.push(`${optionValue}: ${quantity}`);
      }
    });
    return selectedOptions.join(", ");
  };
  const currentAnswersValues = getCurrentAnswersValues();
  const handleCheckboxChange = value_0 => {
    const currentValuesObj = getCurrentAnswersValues();
    const isSelected = currentValuesObj[value_0] !== undefined;
    let newValuesObj;
    if (isSelected) {
      // Remove the option
      const {
        [value_0]: removed,
        ...rest
      } = currentValuesObj;
      newValuesObj = rest;
    } else {
      // Add the option with default quantity
      const option_1 = options.find(opt_1 => opt_1.value === value_0);
      const defaultQuantity = option_1?.allowQuantity ? 1 : 1;
      newValuesObj = {
        ...currentValuesObj,
        [value_0]: defaultQuantity
      };
    }
    setAnswers({
      ...answers,
      [currentQuestionData.id]: {
        ...currentQuestionData,
        values: newValuesObj,
        answer: formatAnswerString(newValuesObj)
      }
    });
  };
  const handleQuantityChange = (value_1, quantity_0) => {
    const currentValuesObj_0 = getCurrentAnswersValues();
    const newValuesObj_0 = {
      ...currentValuesObj_0,
      [value_1]: quantity_0
    };
    setAnswers({
      ...answers,
      [currentQuestionData.id]: {
        ...currentQuestionData,
        question: currentQuestionData.question,
        answer: formatAnswerString(newValuesObj_0),
        values: newValuesObj_0
      }
    });
  };
  return <div>
      <p className="m3-body-large text-[--textDisabledDisabled] mb-3">
        Select all that apply
      </p>
      {options.map((option_2, index) => {
      const isSelected_0 = currentAnswersValues[option_2.value] !== undefined;
      const quantity_1 = currentAnswersValues[option_2.value] || 1;
      return <div key={option_2.value} className={`flex justify-between items-center border border-[-1px solid --colorOutlineOutline] ${index === options.length - 1 ? "" : "border-b-0"}  p-4 gap-3 h-[72px] `}>
            <div className="flex w-full justify-between items-center">
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" checked={isSelected_0} onChange={() => handleCheckboxChange(option_2.value)} className="w-5 h-5 mr-3 cursor-pointer" />
                <span className="m3-body-large text-[--textPrimaryPrimary]">
                  {option_2.label}
                </span>
              </label>
              {option_2.allowQuantity && isSelected_0 && <div className="flex justify-between items-center">
                  <QuantitySelector value={quantity_1} onChange={newQuantity => handleQuantityChange(option_2.value, newQuantity)} min={1} max={option_2.maxQuantity} />
                </div>}
            </div>
          </div>;
    })}
    </div>;
};